import React, { useState } from "react";

import { KeyboardArrowDown } from "@mui/icons-material";
import { useSpring, animated } from "react-spring";
import useMeasure from "react-use-measure";

import useStyles, {
  CollapseHeader,
  CollapsePanel,
  PanelContent,
  Subtitle,
  TitleWrapper,
} from "./styles";

interface CollapsablePanelProps {
  title: React.ReactNode;
  children: React.ReactNode;
  filledBackground?: boolean;
  collapsed?: boolean;
  subtitle?: string;
  panelClassName?: string;
  panelContentClassName?: string;
}

const CollapsablePanel = ({
  title,
  subtitle,
  panelClassName,
  panelContentClassName,
  children,
  filledBackground,
  collapsed = true,
}: CollapsablePanelProps) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const [ref, bounds] = useMeasure();
  const classes = useStyles()();

  const toggleWrapperAnimatedStyle = useSpring({
    transform: isCollapsed ? "rotate(0deg)" : "rotate(180deg)",
  });
  const panelContentAnimatedStyle = useSpring({
    height: isCollapsed ? 0 : bounds.height,
  });

  const togglePanel = () => {
    setIsCollapsed((isCollapsed) => !isCollapsed);
  };

  return (
    <CollapsePanel className={panelClassName} filledBackground={!!filledBackground}>
      <CollapseHeader data-cy="collapse-header" onClick={togglePanel} isCollapsed={isCollapsed}>
        <TitleWrapper>
          <span className={classes.title}>{title}</span>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </TitleWrapper>
        <animated.div style={toggleWrapperAnimatedStyle}>
          <KeyboardArrowDown />
        </animated.div>
      </CollapseHeader>
      <PanelContent style={panelContentAnimatedStyle}>
        <div className={panelContentClassName} ref={ref}>
          {children}
        </div>
      </PanelContent>
    </CollapsePanel>
  );
};

export default CollapsablePanel;
